module.exports = __webpack_public_path__ + "photogallery_icon.png";


//////////////////
// WEBPACK FOOTER
// ./app/photogallery_icon.png
// module id = 3
// module chunks = 0